module.exports = __webpack_public_path__ + "img/blankIMG.8e11bcf4.png";